<template>
    <v-main>
        <v-container>
            <div class="text-center mt-4">
              <i class="fas fa-3x fa-search-minus"></i>
              <h2>Test not found.</h2>
            </div>
        </v-container>
    </v-main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    name: "NotFound",
    computed: {
        ...mapGetters(["isLoading"]),
    },
    methods: {
        ...mapActions(["setLoading"]),
    },
    created(){
        this.setLoading(false);
    }
}
</script>
